import React, { useEffect, useState } from "react"
import { get, remove } from "../../utils/apiClient"
import toast from "react-hot-toast"
import NetIdSharingPermissionModal from "./netIdSharingPermissionModal"
import Pagination from "../common/pagination"
import { displayNetIdEmail } from "../../utils/common"
import { SquarePen, Trash2 } from "lucide-react"
import SearchInputWrapper from "../common/searchInputWrapper"

export default function NetIdSharingPermissionsAssociation({ authUser }) {
  const [records, setRecords] = useState([])
  const [loading, setLoading] = useState(false)
  const [actionLoading, setActionLoading] = useState(false)
  const [modalOpen, setModalOpen] = useState(false)
  const [editData, setEditData] = useState(null)
  const [netIdToDelete, setNetIdToDelete] = useState(null)
  const [activeRowId, setActiveRowId] = useState(null)

  const [currentPage, setCurrentPage] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(10)

  const [searchText, setSearchText] = useState("")

  // Search Filter
  const filteredRecords = records?.filter((queue) => {
    return Object.entries(queue).some(([key, value]) => {
      if (
        [
          "sharedBy",
          "sharedWith",
          "sharedByEmailAddress",
          "sharedWithEmailAddress",
        ].includes(key)
      ) {
        return value
          ?.toString()
          .toLowerCase()
          .includes(searchText.toLowerCase())
      }
      return false
    })
  })

  const fetchList = async () => {
    try {
      const param =
        authUser.loggedInUserType === "USER"
          ? `?sharedBy=${authUser.netId}`
          : ""
      const data = await get(`/manage/shared/by${param}`)
      setRecords(data.sharedByNetIdAccesses || [])
    } catch {
      toast.error("Failed to load queue permissions list")
    }
    setLoading(false)
  }

  const loadList = async () => {
    setLoading(true)
    await fetchList()
    setLoading(false)
  }

  useEffect(() => {
    loadList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleAdd = () => {
    setEditData(null)
    setModalOpen(true)
  }

  const handleEdit = (record) => {
    setEditData(record)
    setModalOpen(true)
  }

  const handleDelete = async (record) => {
    setActionLoading(true)

    try {
      const res = await remove(
        `/manage/share/${record.sharedBy}/with/${record.sharedWith}`,
      )

      toast.success(res.message)
      fetchList()
      setActionLoading(false)
      setNetIdToDelete(null)
    } catch (error) {
      setActionLoading(false)
      setNetIdToDelete(null)
      toast.error(error)
    }
  }

  const handleModalSaved = () => {
    setModalOpen(false)
    fetchList()
  }

  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      {loading ? (
        <div className="loading-container-fax-list">
          <div className="loading-message">Loading...</div>
        </div>
      ) : (
        <div
          className="faxes-content"
          style={{ marginTop: "20px", width: "100%" }}
        >
          {/* <button onClick={handleAdd} style={{ marginBottom: "10px" }}>
            Add
          </button> */}

          <div
            className="search-container"
            style={{
              width: "100%",
              alignItems: "end",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div className="setting-note">
              {/* {records.length === 0
                ? `No other NetIds are assigned to queues owned by you. You are
              currently either sole Owner or Editor for your queues.`
                : `Below are the NetIds assigned to your queues. As the owner, you can manage their roles and permissions for these queues.`} */}
              <div>
                {/* <input
                  type="text"
                  placeholder={`Search ...`}
                  value={searchText}
                  onChange={(e) => {
                    setSearchText(e.target.value)
                    setCurrentPage(1)
                  }}
                /> */}

                <SearchInputWrapper
                  placeholder={`Search ...`}
                  value={searchText}
                  onChange={(val) => {
                    setSearchText(val)
                    setCurrentPage(1)
                  }}
                  onClear={() => {
                    setSearchText("")
                    setCurrentPage(1)
                  }}
                />
              </div>
            </div>
            <button
              className="faxes-button"
              onClick={handleAdd}
              style={{ marginBottom: "5px" }}
            >
              + Share NetId
            </button>
          </div>
          <div className="table-container">
            <table className="faxes-table">
              <thead>
                <tr>
                  <th className="faxes-th">Shared By</th>
                  <th className="faxes-th">Shared With</th>
                  {/* <th className="faxes-th">Permissions</th> */}
                  <th className="faxes-th" style={{ width: "50px" }}>
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredRecords.length > 0 ? (
                  <>
                    {filteredRecords.map((rec) => (
                      <tr
                        key={rec.uuid}
                        className={activeRowId && activeRowId === `${rec.sharedBy}_${rec.sharedWith}` ? "fax-action-active" : ""}
                        onMouseEnter={() => { if (activeRowId && activeRowId !== `${rec.sharedBy}_${rec.sharedWith}`) setActiveRowId(null) }}
                      >
                        <td className="faxes-td">
                          {displayNetIdEmail(
                            rec.sharedBy,
                            rec.sharedByEmailAddress,
                          )}
                        </td>
                        <td className="faxes-td">
                          {displayNetIdEmail(
                            rec.sharedWith,
                            rec.sharedWithEmailAddress,
                          )}
                        </td>
                        {/* <td className="faxes-td">
                      {Object.entries(rec.permissions).map(([cat, perms]) =>
                        perms.length ? (
                          <div key={cat}>
                            <b>{cat}:</b> {perms.join(", ")}
                          </div>
                        ) : null
                      )}
                    </td> */}
                        <td
                          className="faxes-td"
                          style={{ textAlign: "center" }}
                        >
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() => { setActiveRowId(`${rec.sharedBy}_${rec.sharedWith}`); handleEdit(rec) }}
                          >
                            <SquarePen size="18" color="black" />
                          </span>
                          <span
                            style={{ cursor: "pointer", marginLeft: "10px" }}
                            onClick={() => { setActiveRowId(`${rec.sharedBy}_${rec.sharedWith}`); setNetIdToDelete(rec) }}
                          >
                            <Trash2 size="18" color="red" />
                          </span>
                        </td>
                      </tr>
                    ))}
                  </>
                ) : (
                  <tr>
                    <td
                      colSpan="100%"
                      style={{
                        textAlign: "center",
                        padding: "10px",
                        border: "1px solid #ccc",
                      }}
                    >
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {filteredRecords.length > 0 && (
            <div
              className="faxes-pagination"
              style={{
                marginTop: "8px",
                display: "flex",
                justifyContent: "end",
              }}
            >
              <Pagination
                currentPage={currentPage}
                totalPages={Math.ceil(filteredRecords.length / rowsPerPage)}
                rowsPerPage={rowsPerPage}
                totalRows={filteredRecords.length}
                onPageChange={(page) => setCurrentPage(page)}
                onRowsPerPageChange={(count) => {
                  setRowsPerPage(count)
                  setCurrentPage(1) // Reset to first page on change
                }}
              />
            </div>
          )}

          {modalOpen && (
            <NetIdSharingPermissionModal
              onClose={() => setModalOpen(false)}
              onSaved={handleModalSaved}
              editData={editData}
              authUser={authUser}
            />
          )}

          {netIdToDelete && (
            <DeleteConfirmationPopup
              onConfirm={() => handleDelete(netIdToDelete)}
              onCancel={() => setNetIdToDelete(null)}
              actionLoading={actionLoading}
              netIdIdToDelete={netIdToDelete}
            />
          )}
        </div>
      )}
    </div>
  )
}

const DeleteConfirmationPopup = ({
  onConfirm,
  onCancel,
  actionLoading,
  netIdIdToDelete,
}) => (
  <div className="popup-overlay">
    <div className="popup" style={{ padding: "20px", maxWidth: "700px" }}>
      {actionLoading ? (
        <div>Processing...</div>
      ) : (
        <>
          {/* <h3>Confirm Deletion</h3> */}
          <p>
            Are you sure to remove the access shared by NetID
            <strong> {netIdIdToDelete?.sharedBy}</strong> with NetID
            <strong> {netIdIdToDelete?.sharedWith}?</strong>
          </p>
          {/* <p>⚠️ Deleting this netId will clean up all related associations.</p> */}
          <div className="popup-buttons">
            <button className="cancel" onClick={onCancel}>
              Cancel
            </button>
            <button className="delete" onClick={onConfirm}>
              Delete
            </button>
          </div>
        </>
      )}
    </div>
  </div>
)
